import React from 'react';
import { OverridableComponentProps } from 'types';
import PlaybackAwareDestinationLink from './PlaybackAwareDestinationLink';
import PlaybackUnawareDestinationLink from './PlaybackUnawareDestinationLink';

interface Props {
  playbackAware?: boolean;
}

export type PodcastDestinationLinkProps<As extends React.ElementType = 'a'> =
  OverridableComponentProps<Props, As>;

function PodcastDestinationLink<As extends React.ElementType = 'a'>({
  playbackAware = true,
  ...props
}: PodcastDestinationLinkProps<As>) {
  return playbackAware ? (
    <PlaybackAwareDestinationLink {...props} />
  ) : (
    <PlaybackUnawareDestinationLink {...props} />
  );
}
export default PodcastDestinationLink;
